export const CHIP_SIZES = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
} as const;

export type ChipSize = (typeof CHIP_SIZES)[keyof typeof CHIP_SIZES];

/** Type guard for ChipSize - to make sure we aren't modifying legacy Chip usage */
export const isValidChipSize = (size: unknown): size is ChipSize => {
  return Object.values(CHIP_SIZES).includes(size as ChipSize);
};

export const CHIP_VARIANTS = {
  PILL: 'pill', // badge.pill in DS
  CHIP: 'badge', // badge.badge in DS
  TAG: 'tag', // tag.tag in DS
} as const;

export type ChipVariant = (typeof CHIP_VARIANTS)[keyof typeof CHIP_VARIANTS];

export const isValidChipVariant = (variant: unknown): variant is ChipVariant => {
  return Object.values(CHIP_VARIANTS).includes(variant as ChipVariant);
};

export const CHIP_TYPES = {
  DEFAULT: 'default',
  LEADING: 'leading',
  TRAILING: 'trailing',
  ONLY: 'only',
} as const;

export type ChipType = (typeof CHIP_TYPES)[keyof typeof CHIP_TYPES];

/** Type guard for ChipType - to make sure we aren't modifying legacy Chip usage */
export const isValidChipType = (type: unknown): type is ChipType => {
  return Object.values(CHIP_TYPES).includes(type as ChipType);
};

export type CustomChipVariants = Readonly<{
  pill: React.CSSProperties;
  badge: React.CSSProperties;
}>;

export type CustomChipPropsVariantOverrides = Readonly<{
  pill: true;
  badge: true;
  tag: true;
  sm: true;
  md: true;
  lg: true;
  default: true;
  leading: true;
  trailing: true;
  only: true;
  primary: true;
  secondary: true;
  success: true;
  warning: true;
  error: true;
  info: true;
}>;
